module.exports = __webpack_public_path__ + "media/images/flags/4x3/btn-7b92eb4c0c8fc1b0b144ae7c57b45c15.svg";